import React, { useState } from "react";
import classes from './Posts.module.css'
import UserProfile from "../../../lms-shared/UI/UserProfile";
import defaultAvatar from '../../../../assests/user-profile/default-avatar.png'
import { useSelector } from "react-redux";
import Moment from 'moment'
import Post from "./Post";
import Scroll from "../../../lms-shared/UI/Scroll";

const Posts = ({ currentPostType, PostTypeEnum, currentParticipant, currentPosts, setCurrentPostsInUseEffect, changePosts, handeleSaveEditChanges, friendsData }) => {

    const { direction, texts } = useSelector((state) => state.translate);
    const [currentPostPlay, setCurrentPostPlay] = useState();

    // temp
    // function uuidv4() {
    //     return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    //         (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    //     );
    // }

    const getDateAgo = (p) => {
        let now = Moment()
        var b = Moment(p.updatedDate);
        let date = now.diff(b, 'days')   // =1
        if (date == 1)
            return texts.yesterday
        else if (date == 0)
            return texts.today
        return `${texts.before} ${date} ${texts.days}`
    }

    const playPost = (postData) => {
        let ide = postData.contentData
        if (ide) {
            let project = {
                // assessmentName: p.name,
                ideUrl: ide.Ide.Url,
                ideConfig: JSON.parse(ide.Ide.AdditionalConfiguration),
                ideLang: ide.Ide.Lang ? ide.Ide.Lang : "he",
                fileUrl: postData.url,
                share: true
            }
            setCurrentPostPlay({ id: postData.id, projectData: project });
        }
    }



    return (
        <Scroll className={`${classes[direction]} ${classes.PostContainer}`} noMore={currentPosts.noMore} setCurrentData={setCurrentPostsInUseEffect}>
            {currentPosts.posts && <div className={classes.PostsDirections}>
                {currentPosts.posts.length > 0 && currentPostType === PostTypeEnum.participants && currentParticipant != 0 && <div className={classes.PostHeader}>
                    {currentPosts.posts[0].user &&
                        <div className={classes.UserWarrper}>
                            <UserProfile width="84px" image={currentPosts.posts[0].user.profileImage ? `${currentPosts.posts[0].user.profileImage}` : defaultAvatar} />
                            <div className={classes.User}>
                                <div className={classes.UsesDetails}>
                                    <div> {currentPosts.posts[0].user.firstName} {currentPosts.posts[0].user.lastName} </div>
                                    <div >{currentPosts.posts[0].user.schoolName} </div>
                                    {currentPosts.posts[0].user.class ? <div >{texts.class} {currentPosts.posts[0].user.class}</div> : ''}
                                </div>
                                <div className={classes.Date}> {texts.LastShare}: {getDateAgo(currentPosts.posts[0])}</div>
                            </div>
                        </div>}
                    <div className={classes.NumPosts}>
                        <div className={classes.Icon}>+</div>
                        <div> {currentPosts.posts.length} {texts.posts}</div>
                    </div>
                </div>}

                {currentPosts.posts && currentPosts.posts.map((p, i) =>
                    <Post key={i} p={p} play={currentPostPlay && p.id === currentPostPlay.id} currentPostPlay={currentPostPlay} setCurrentPostPlay={setCurrentPostPlay} getDateAgo={getDateAgo} changePosts={changePosts} handeleSaveEditChanges={handeleSaveEditChanges} friendsData={friendsData} />
                )}

            </div>}
        </Scroll>
    )
}
export default Posts